import { resolveOptimizedImage } from '@/utils/gumlet';

export const selectCategoryImage = (thumbnail?: string) => {
  // Return the thumbnail if available, otherwise return the fallback image
  const src = thumbnail && thumbnail.trim() !== '' ? thumbnail : '/imgs/image-not-found.png';
  return resolveOptimizedImage(src, 'categoryCard');
};
